// extracted by mini-css-extract-plugin
export var active = "_h2-2";
export var recordingDot = "_h2-1";
export var recordingIndicator = "_h2-0";